/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Why_Files_TitleInputs */

const en_wc_why_files_title = /** @type {(inputs: Wc_Why_Files_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your files, your formats`)
};

/**
* | output |
* | --- |
* | "Your files, your formats" |
*
* @param {Wc_Why_Files_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_why_files_title = /** @type {((inputs?: Wc_Why_Files_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Why_Files_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_why_files_title(inputs)
});
export { wc_why_files_title as "wc.why.files.title" }